import React from "react";
import "./App.css";
import Header from "./components/Header";
import Hero from "./components/Hero";
import About from "./components/About";
import Menu from "./components/Menu";
import Gallery from "./components/Gallery";
import Hours from "./components/Hours";
import Reservation from "./components/Reservation";
import Footer from "./components/Footer";

function App() {
  return (
    <div className="App relative" data-testid="poseidon-app">
      <Header />
      <main>
        <Hero />
        <About />
        <Menu />
        <Gallery />
        <Hours />
        <Reservation />
      </main>
      <Footer />
    </div>
  );
}

export default App;
